export const ISetLanguageUseCaseType = Symbol('ISetLanguageUseCase');
